window.addEventListener('load', () => {
    setTimeout(() => {
      const storeBadges = Array.from(document.querySelectorAll(".store-badges .badge"));
      const discountBadgeId = "gid://shopify/Metaobject/85300871495";

      // Loop through each Nosto product element
      document.querySelectorAll("[data-product-badges]").forEach((nostoEl) => {

        nostoEl.style.paddingTop = '15px'
        const nostoImagesEl = nostoEl.querySelector('.nosto-product-images');
        const nostoListParent = nostoEl.closest('.nosto-list');
        if (nostoListParent) {
          nostoListParent.style.marginTop = '-15px';
        }

        // Parse the data-product-badges array
        let productBadgeIds;
        try {
          let raw = nostoEl.getAttribute("data-product-badges").replace(/&quot;/g, '"');

          // If it doesn't start with [ … ], wrap it into an array
          if (!raw.trim().startsWith("[")) {
            raw = `[${raw}]`;
          }

          productBadgeIds = JSON.parse(raw);
        } catch (e) {
          console.warn("Failed to parse data-product-badges", e);
          productBadgeIds = [];
        }

        // Check if product is discounted by looking for both new and old prices
        const newPriceEl = nostoEl.querySelector('.nosto-newprice');
        const oldPriceEl = nostoEl.querySelector('.nosto-oldprice');
        const isDiscounted = newPriceEl && oldPriceEl;

        // Loop through productBadgeIds and find matching badges
        productBadgeIds.forEach((prodId) => {
          const cleanId = prodId.replace(/^"|"$/g, ''); // remove leading/trailing quotes
          console.log("tova raboti tuk");

          const matchingBadge = storeBadges.find(
            (badge) => badge.getAttribute("data-badge-id") === cleanId
          );
          if (matchingBadge) {
            const badgeClone = matchingBadge.cloneNode(true);
            nostoImagesEl.appendChild(badgeClone);
          }
        });

        // Add discount badge if product is discounted
        if (isDiscounted) {
          const discountBadge = storeBadges.find(
            (badge) => badge.getAttribute("data-badge-id") === discountBadgeId
          );
          if (discountBadge) {
            const discountBadgeClone = discountBadge.cloneNode(true);
            nostoImagesEl.appendChild(discountBadgeClone);
          }
        }

      });
    }, 2000);
  });